import { treaty } from "@elysiajs/eden";
import { QueryClient } from "@tanstack/react-query";
import type { App } from "@server";

export const clientId = crypto.randomUUID();

export const api = treaty<App>(window.location.origin, {
  headers: { "x-client-id": clientId },
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60,
      refetchOnWindowFocus: false,
    },
  },
});
